export enum CreateVideoClickTarget {
  CreateNewVideoTop = 'create_new_video_top',
  CreateNewVideoGallery = 'create_new_video_gallery',
  GetStarted = 'get_started',
  CreateNewVideoEmptyState = 'create_new_video_empty_state',
}

export enum ActionsTarget {
  ActionsClick = 'actions_click',
  Share = 'share',
  Download = 'download',
  Duplicate = 'duplicate',
  Delete = 'delete',
  Edit = 'edit',
  Play = 'play',
}
